import React from 'react';

export default class Tabs extends React.Component {
    componentDidMount() {
        this.dom.addEventListener('change', this._onChangeIndex, false);
    }

    componentWillUnmount() {
        this.dom.removeEventListener('change', this._onChangeIndex);
    }

    render() {
        const tabs = this._renderTabs();
        const breaks = this._renderBreakPoints();

        return (
            <dui-tabs ref={dom => this.dom = dom}
                id={this.props.id}
                selected={this.props.selectedIndex}
                tabs={JSON.stringify(tabs)}
                breaks={JSON.stringify(breaks)}>
                <style>{this.props.css}</style>
            </dui-tabs>
        );
    }

    _renderTabs() {
        return this.props.tabs || [];
    }

    _renderBreakPoints() {
        return this.props.breaks || [{ width: 0, count: 1 }, { width: 375, count: 2 }, { width: 576, count: 3 }, { width: 768, count: 4 }, { width: 992, count: 6 }, { width: 1200, count: 8 }]
    }

    _onChangeIndex = (e) => {
        this.props.onChange && this.props.onChange(e.detail.selected);
    }
}